import { Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalStorage } from "./helper/localStorageHelper";
import { AppConstant } from './constant/AppConstant';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from "react-toastify";
import Sidebar from "./layout/Sidebar";
import { setNavigate } from "./helper/utility";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/index.css";

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  setNavigate(navigate);
  const is404Page = location.pathname === "/404";
  const is500Page = location.pathname === "/500";
  const isAuthRoute = location.pathname.includes("/auth");
  const isAuthenticated = Boolean(getLocalStorage(AppConstant.authToken));

  return (
    <>
      {!isAuthRoute && !is404Page && !is500Page && (
        <Sidebar />
      )}
      <main className={`custom-content ${isAuthRoute ? 'auth-page' : ''}`}>
        <Suspense fallback={null}>
          <AppRoutes isAuthenticated={isAuthenticated} />
          <ToastContainer />
        </Suspense>
      </main>

    </>
  );
}

export default App;
